<template>
  <apexchart 
             v-bind:series="timeline"
             v-bind:options="{}"
             v-bind:height="500"/>
</template>

<script>
import util from '../../util'

export default {
  name: 'AccountDetailsTimeline',

  props : {
    txs: Array
  },

  computed : {
    timeline : function(){
      // TODO
    }
  }
}
</script>

<style scoped>
</style>
